export { default as SendFunds } from './ui/SendFunds'